import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  ISSUER,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchIssuer = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.ISSUER}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.ISSUER}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.ISSUER}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.ISSUER}${query}${sorting}`);
};

const postIssuer = async ({ params }) => axiosAuthInstance.post(API_END_POINTS.ISSUER, params);

export function* getIssuer(action) {
  try {
    const { data: { entity } } = yield call(fetchIssuer, action.payload);
    yield put({ type: ISSUER.SUCCESS, payload: entity });
  } catch (e) {
    yield put({ type: ISSUER.FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  }
}

export function* addIssuer(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(postIssuer, action.payload);
    const { data: { entity } } = yield call(fetchIssuer, action.payload);
    yield put({ type: ISSUER.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.ISSUER.ADD_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
